import React, { useRef, useState, useEffect } from 'react'
import { CToast, CToastBody, CToastClose, CToaster } from '@coreui/react'
import { cilCheckCircle, cilWarning } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { useSelector } from 'react-redux'

const TopRightToast = () => {
  const [toast, addToast] = useState(0)
  const toaster = useRef()
  const status = useSelector((state) => state.isToast)
  const content = useSelector((state) => state.toastContent)
  const toasted = useSelector((state) => state.toasted)

  const toastBody = (
    <CToast
      className="toast-body-custom"
      style={status === true ? { backgroundColor: '#2eb85c' } : { backgroundColor: '#e55353' }}
      animation={true}
      delay={3000}
      // autohide={false}
    >
      <div className="d-flex" style={{ alignItems: 'center' }}>
        {status === true ? (
          <CIcon
            icon={cilCheckCircle}
            style={{ color: 'white', paddingLeft: '15px', minWidth: '32px' }}
          />
        ) : (
          <CIcon
            icon={cilWarning}
            style={{ color: 'white', paddingLeft: '15px', minWidth: '32px' }}
          />
        )}

        <CToastBody style={{ color: 'white', fontSize: '15px' }}>{content}</CToastBody>
        <CToastClose className="me-2 m-auto" white />
      </div>
    </CToast>
  )

  useEffect(() => {
    if (status === true || status === false) {
      addToast(toastBody)
    }
  }, [toasted])

  return (
    <>
      <CToaster ref={toaster} push={toast} placement="top-end" />
    </>
  )
}
export default TopRightToast
